import React, { Component } from 'react';
import enums from '../../../../../constants/enums';

export default ({ needToKeep, type, code, pin }) => {
  const card = enums.giftcardLinks[type];
  let link;
  if(card && card.url){
    const url = needToKeep && card.keepUrl ? card.keepUrl : card.url;
    link = card.hasHash ? url : `${url}#code=${code}&pin=${pin}`;
  }
  return link ? (
    <a href={link} target="_blank">{code}</a>
  ) : (<span>{code}</span>);
};



// WEBPACK FOOTER //
// ./src/app/modules/WorkArea/Trades/TradeDetails/@components/CardLink.js